<template>
  <div class="suspicious-donut">
    <div class="suspicious-donut__header">Top 5 Suspicious Domain</div>
    <div class="suspicious-donut__body">
      <div ref="chartDiv" style="width: 100px; height: 100px; flex-shrink: 0;"></div>
      <div class="suspicious-donut__legend">
        <div
          v-for="(item, idx) in domains"
          :key="idx"
          class="suspicious-donut__legend-row"
        >
          <span class="suspicious-donut__dot" :style="{ background: palette[idx % palette.length] }"></span>
          <span class="suspicious-donut__domain-name">{{ item.name }}</span>
          <span class="suspicious-donut__domain-stat">{{ item.count }} ({{ item.percent }}%)</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

export default {
  name: 'DomainSummarySuspiciousDonut',
  props: {
    domains: {
      type: Array,
      default: () => [],
      // each: { name, count, percent }
    },
  },
  data() {
    return {
      chart: null,
      palette: ['#2196F3', '#8BC34A', '#FFC107', '#FF7043', '#9E9E9E'],
    }
  },
  watch: {
    domains(val) {
      if (this.chart) this.chart.data = this.buildChartData(val)
    },
  },
  mounted() {
    am4core.useTheme(am4themes_animated)
    const chart = am4core.create(this.$refs.chartDiv, am4charts.PieChart)
    chart.innerRadius = am4core.percent(60)
    chart.paddingTop = 0
    chart.paddingBottom = 0
    chart.paddingLeft = 0
    chart.paddingRight = 0

    const series = chart.series.push(new am4charts.PieSeries())
    series.dataFields.value = 'count'
    series.dataFields.category = 'name'
    series.labels.template.disabled = true
    series.ticks.template.disabled = true
    series.slices.template.strokeWidth = 2
    series.slices.template.strokeOpacity = 1
    series.slices.template.stroke = am4core.color('#fff')
    series.colors.list = this.palette.map(c => am4core.color(c))

    chart.data = this.buildChartData(this.domains)
    this.chart = chart
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    buildChartData(domains) {
      if (!domains || !domains.length) return [{ name: 'No Data', count: 1 }]
      return domains.map(d => ({ name: d.name, count: d.count }))
    },
  },
}
</script>

<style scoped>
.suspicious-donut {
  background: white;
  border-radius: 8px;
  box-shadow: 0 0 1.5px rgba(0,0,0,0.16);
  padding: 16px;
}

.suspicious-donut__header {
  font-size: 13px;
  font-weight: 600;
  color: #4b4b4b;
  margin-bottom: 12px;
  white-space: nowrap;
}

.suspicious-donut__body {
  display: flex;
  align-items: center;
  gap: 16px;
}

.suspicious-donut__legend {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.suspicious-donut__legend-row {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 2px 0;
}

.suspicious-donut__dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.suspicious-donut__domain-name {
  font-size: 10px;
  color: #4b4b4b;
  white-space: nowrap;
}

.suspicious-donut__domain-stat {
  font-size: 10px;
  font-weight: 500;
  color: #707070;
  white-space: nowrap;
}
</style>
